module.exports = __webpack_public_path__ + "static/media/word_icon.0e18ea28.png";